import { Autocomplete, AutocompleteProps, Input, InputWrapperProps } from "@mantine/core";
import { useFormHelperContext } from "../form";
import { useController } from "react-hook-form";
import { InputWrapper } from "../inputWrapper";
import { useEffect, useRef, useState } from "react";

interface data {
    label: string;
    value: string;
}
export interface FieldInputAutocompleteProps extends AutocompleteProps {
    label: string;
    name: string;
    inputWrapper?: InputWrapperProps;
    data: data[] | undefined;
    readOnly?: boolean;
}


export const FieldInputAutocomplete: React.FC<FieldInputAutocompleteProps> = ({ label, name, placeholder, inputWrapper, data, readOnly, ...rest }) => {
    const { register, control, watch, formStore } = useFormHelperContext();
    const { field, fieldState: { error }, } = useController({ name, control });
    const [selectable, setSelectable] = useState<string[]>([]);
    const [selectedValue, setSelectedValue] = useState<string | undefined>(undefined);
    const initialDefaultValue = useRef<string | undefined>(undefined);


    useEffect(() => {
        if (field.value) {
            const resolvedValue = data?.find((item) => item.value === field.value)?.label;
            if (initialDefaultValue.current === undefined) {
                initialDefaultValue.current = resolvedValue ?? field.value; // Set hanya sekali
            }
            setSelectedValue(resolvedValue ?? field.value);
        }
    }, [field.value, data]);

    useEffect(() => {
        if (data) { 
            const parsedData = data.map((item) => item.label);
            const uniqueData = Array.from(new Set([...parsedData, initialDefaultValue.current].filter(Boolean))) as string[];
            setSelectable(uniqueData);
        }
    }, [data]);



    const resolveLabelToValue = (label: string) => {
        if (label === initialDefaultValue.current) {
            return initialDefaultValue.current // Jika memilih default value pertama, kembalikan field.value
        }
        return data?.find((item) => item.label === label)?.value ?? label;
    };

    if (!register) {
        throw new Error("Field.Autocomplete must be used within a FormHelper component");
    }

    return (
        <InputWrapper label={label} {...inputWrapper} withAsterisk={rest.withAsterisk}>
            <div className="flex flex-col w-full">
                <Autocomplete
                    data={selectable}
                    placeholder={placeholder}
                    readOnly={readOnly ?? formStore.readOnly}
                    data-testid={'field-autocomplete-' + name}
                    {...field}
                    {...rest}
                    value={selectedValue}
                    onChange={(value) => {
                        setSelectedValue(value);
                        // resolve array to get value from data 
                        field.onChange(resolveLabelToValue(value));
                    }}
                />

                {error && (
                    <Input.Error>{error.message}</Input.Error>
                )}
            </div>
        </InputWrapper>

    );
};

